module.exports = __webpack_public_path__ + "img/favicon-ocelor.109cac57.svg";